export const LOGIN_CALLBACK = 'LOGIN_CALLBACK'
export const LOGOUT = 'LOGOUT'

export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE'
